import React from "react";
import styled from "styled-components";
import { getAvatar } from "./avatars";

export interface TestimonialData {
  userName: string;
  quote: string;
}

export const Testimonial: React.FC<{ testimonial: TestimonialData }> = ({
  testimonial
}) => (
  <Wrapper>
    <Avatar src={getAvatar(testimonial.userName)} alt="" />
    <Username>{testimonial.userName}</Username>
    <Quote>{testimonial.quote}</Quote>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 22px;
`;

const Avatar = styled.img``;

const Username = styled.h5`
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Quote = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.67;
  text-align: center;
  color: #ffffff;
`;
